/* src/app/components/analytics/near-dup-text-groupings/near-dup-text-groupings.component.scss */
.nearDupGroupBrowseLink {
  text-decoration: none;
  font-size: 16px;
}
/*# sourceMappingURL=near-dup-text-groupings.component.css.map */
